import { graphql } from "@/gql";
import { ResultOf } from "@graphql-typed-document-node/core";

export type BlogTagListItem = ResultOf<
  typeof blogTagListQuery
>["blogTags"][number];

export const blogTagListQuery = graphql(`
  query BlogTagList {
    blogTags {
      id
      name
      slug
    }
  }
`);

export const createBlogTagMutation = graphql(`
  mutation CreateBlogTag($input: CreateBlogTagInput!) {
    createBlogTag(input: $input) {
      id
    }
  }
`);

export const updateBlogTagMutation = graphql(`
  mutation UpdateBlogTag($id: ID!, $input: UpdateBlogTagInput!) {
    updateBlogTag(id: $id, input: $input) {
      id
    }
  }
`);

export const deleteBlogTagMutation = graphql(`
  mutation DeleteBlogTag($id: ID!) {
    deleteBlogTag(id: $id) {
      id
    }
  }
`);
